import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

function Thermocouple() {
  const [inputValue, setInputValue] = useState("");
  const [uncertainty, setUncertainty] = useState("");

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);

    const value = parseFloat(val);
    if (!val) {
      setUncertainty("");
      return;
    }

    if (isNaN(value)) {
      setUncertainty("Invalid input");
      return;
    }

    if (value >= -30 && value < 50) {
      setUncertainty(`0.3`);
    } else if (value >= 50 && value < 155) {
      setUncertainty(`0.4`);
    } else if (value >= 155 && value <= 600) {
      const calculated = 0.00066 * value + 0.67;
      // Limit to 2 decimals
      setUncertainty(`${calculated.toFixed(2)}`);
    } else {
      setUncertainty("Out of range");
    }
  };

  const handleCopy = () => {
    if (uncertainty && uncertainty !== "Out of range" && uncertainty !== "Invalid input") {
      navigator.clipboard.writeText(uncertainty);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Enter Value (°C)"
        variant="outlined"
        type="number"
        value={inputValue}
        onChange={handleChange}
        fullWidth
      />
      <TextField
        label="Uncertainty (± °C)"
        variant="outlined"
        value={uncertainty}
        InputProps={{
          readOnly: true,
        }}
        fullWidth
      />
      <Button
        variant="contained"
        onClick={handleCopy}
        disabled={!uncertainty || uncertainty === "Out of range" || uncertainty === "Invalid input"}
      >
        Copy
      </Button>
    </Box>
  );
}

export default Thermocouple;
